/**
 * Voucher and gift card fields of the payment and order step.
 *
 * Markup contract:
 *   <div x-data="voucherForm({ parentClass: 'payment' })">
 *     <input name="voucherNr" aria-describedby="voucher_payment_error"
 *            data-error-value-missing="…" @keydown.enter.prevent>
 *     <p class="ddhes-form--el---error" id="voucher_payment_error"></p>
 *     <button type="button" @click="redeemVoucher()">
 *
 * The fields sit inside the checkout form but are not part of it: they carry no
 * required attribute, so they never hold the step's submit, and Enter in them
 * must not send the step either. Redeeming replaces the sticky basket fragment.
 */
import { stickyBasketAction } from './stickyBasket.js';

document.addEventListener('alpine:init', () => {
    Alpine.data('voucherForm', ({ parentClass }) => ({
        isRedeeming: false,

        redeemVoucher() {
            const number = this.field('voucherNr');

            if (!this.filled(number)) {
                return;
            }

            return this.redeem('addVoucher', { voucherNr: number.value.trim(), parentClass }, [number]);
        },

        redeemGiftCard() {
            const number = this.field('GiftCardNr');
            const pin = this.field('GiftCardPin');
            // both fields answer at once, so the customer sees every missing one
            const complete = [this.filled(number), this.filled(pin)].every(Boolean);

            if (!complete) {
                return;
            }

            return this.redeem(
                'addGiftCard',
                { giftCardNr: number.value.trim(), giftCardPin: pin.value.trim(), parentClass },
                [number, pin],
            );
        },

        // by name, not $refs: the number field is a component of its own and keeps its ref to itself
        field(name) {
            return this.$root.querySelector(`[name="${name}"]`);
        },

        async redeem(fnc, body, fields) {
            if (this.isRedeeming) {
                return;
            }

            this.isRedeeming = true;
            try {
                await stickyBasketAction(fnc, body);
                fields.forEach((field) => { field.value = ''; });
            } finally {
                this.isRedeeming = false;
            }
        },

        /**
         * Writes the field's own error text, following the markup contract of
         * validatedForm without taking part in the enclosing form's validation.
         */
        filled(field) {
            const empty = field.value.trim() === '';

            document.getElementById(field.getAttribute('aria-describedby')).textContent =
                empty ? field.dataset.errorValueMissing : '';
            field.closest('.ddhes-form--el').classList.toggle('is-invalid', empty);

            return !empty;
        },
    }));
});
